import { render, staticRenderFns } from "./user_tag_order.vue?vue&type=template&id=546bdd82&"
import script from "./user_tag_order.vue?vue&type=script&lang=ts&"
export * from "./user_tag_order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports